// extracted by mini-css-extract-plugin
export default {"box":"index_box_TDg6K","logo":"index_logo_L1DSx","slogan":"index_slogan_uKOBU","banner":"index_banner_szD8m","search":"index_search_RaLHG"};